import React from 'react'
import { Link } from 'react-router-dom'
import type { LinkProps } from 'react-router-dom'
import { Button } from 'semantic-ui-react'

import './styles.css'

interface SocialLoginButtonProps {
  children: React.ReactNode
  icon: string
  iconAlt: string
  to?: LinkProps['to']
  onClick?: () => void
}

export default function SocialLoginButton({
  children,
  icon,
  iconAlt,
  to,
  onClick,
}: SocialLoginButtonProps) {
  const linkProps = to ? { as: Link, to } : {}

  return (
    <Button {...linkProps} basic fluid onClick={onClick} className="social-login-button">
      <span className="social-login-button__content">
        <span className="social-login-button__icon">
          <img src={icon} alt={iconAlt} />
        </span>
        {children}
      </span>
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/SocialLoginButton/index.tsx